import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { fn } from '@app/utils';
import { StyledCard } from '@app/components/card/Card';
import { url } from '@app/utils/constants';
import { PageMeta } from '@app/components/meta/Meta';
import { LoginForm } from './components/LoginForm';
import useAuthActions from '@app/hooks/auth/useAuthActions';
import { MfaForm } from './components/MfaForm';
import type { LoginFormValues } from './components/LoginForm';
import type { LoginParams } from '@app/services/auth.types';

export const Home = () => {
    const { login, resendMfaCode } = useAuthActions();
    const navigate = useNavigate();
    const [showMFA, setShowMFA] = useState({
        visible: false,
        data: {} as LoginFormValues,
    });

    const handleLoginSubmit = async (data: LoginFormValues) => {
        try {
            await login.mutateAsync(data, {
                onSuccess: (res) => {
                    if (res?.challenge === 'TWO_FA_REQUIRED') {
                        setShowMFA({
                            visible: true,
                            data,
                        });
                    } else if (res?.token) {
                        navigate(url.adminPortal.dashboard);
                    }
                },
            });
        } catch {
            // Ignore this error as React Query should handle it above
        }
    };

    const handleMfaSubmit = async (code: string) => {
        try {
            const data: LoginParams = {
                ...showMFA.data,
                code,
            };
            await login.mutateAsync(data, {
                onSuccess: (res) => {
                    if (res?.token) {
                        navigate(url.adminPortal.dashboard);
                    }
                },
            });
        } catch {
            // Ignore this error as React Query should handle it above
        }
    };

    const handleMfaResend = async () => {
        resendMfaCode.mutate(showMFA.data);
    };

    useEffect(() => {
        if (fn.isLoggedIn()) {
            navigate(url.adminPortal.dashboard);
        }
    }, [navigate]);

    return (
        <>
            <PageMeta title="Home" />

            <StyledCard showLogo style={{ width: '100%', maxWidth: 680 }}>
                {showMFA.visible ? (
                    <MfaForm
                        onSubmit={handleMfaSubmit}
                        onResend={handleMfaResend}
                        loading={login.isPending}
                        resendLoading={resendMfaCode.isPending}
                    />
                ) : (
                    <LoginForm onSubmit={handleLoginSubmit} />
                )}
            </StyledCard>
        </>
    );
};

export default Home;
